var _path, _path2, _circle, _circle2, _rect;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.033 6h.5a.5.5 0 00-.5-.5V6zm0 12v.5a.5.5 0 00.5-.5h-.5zM10.04 6v-.5a.5.5 0 00-.472.337L10.04 6zM7.825 6l.473-.163a.5.5 0 00-.473-.337V6zM4.033 6v-.5a.5.5 0 00-.5.5h.5zm0 12h-.5a.5.5 0 00.5.5V18zm3.754 0v.5a.5.5 0 00.488-.392L7.787 18zm2.29 0l-.488.108a.5.5 0 00.488.392V18zM21.533 6v12h1V6h-1zm-11.494.5h11.994v-1H10.04v1zm-.472-.663a.676.676 0 01-.635.463v1c.737 0 1.354-.48 1.58-1.137l-.945-.326zm-.635.463a.676.676 0 01-.634-.463l-.946.326A1.676 1.676 0 008.932 7.3v-1zm-4.899.2h3.792v-1H4.033v1zm.5 11.5V6h-1v12h1zm3.254-.5H4.033v1h3.754v-1zm.488.608a.68.68 0 01.657-.541v-1A1.68 1.68 0 007.3 17.892l.976.216zm.657-.541a.68.68 0 01.657.541l.976-.216a1.68 1.68 0 00-1.633-1.325v1zm13.101-.067H10.077v1h11.956v-1z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.577 8.562v6.66",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3",
    className: "stroke"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "scale(-1 1) rotate(45 -19.328 -11.924)",
    stroke: "#222",
    className: "stroke"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "scale(-1 1) rotate(45 -25.364 -14.424)",
    stroke: "#222",
    className: "stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.277,
    y: 8.818,
    width: 1,
    height: 8,
    rx: 0.5,
    transform: "rotate(45 18.277 8.818)",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.bcf7b174.svg";
export { ForwardRef as ReactComponent };